import axios from "@/utils/axios";

export async function getListOptions(include_custom_km_type : boolean) {

    const payload = {
        include_custom_km_type : include_custom_km_type
    }

    const response = await axios.get(`utils/v2/utils/list_options`, payload)
    return response.data
}